module.exports = __webpack_public_path__ + "img/Lima Hotpot.3e7b1c97.svg";